/** Values that count as "consent given" for HubSpot gating (v1). */
export function isMarketingConsentTruthy(value: unknown): boolean {
	if (value === true) {
		return true;
	}
	if (value === 1) {
		return true;
	}
	if (typeof value === "string") {
		const t = value.trim().toLowerCase();
		return t === "true" || t === "on" || t === "yes" || t === "1";
	}
	return false;
}
